/**
 * @file_purpose  component created for auth (login and register) modal
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 13-03-2024
 */

import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from "react-bootstrap/Modal";
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { toast } from 'react-toastify';
import { storeUserDetails } from '../../redux/slices/UserDetailSlice.js';
import { setSelectedLanguage } from '../../redux/slices/selectGameLaunchLanguageStateSlice.js';
import { storeLoginCredentials } from '../../redux/slices/authSlice.js';
import Loader from '../commonComp/Loader.jsx';
import { FormattedMessage } from "react-intl";

const AuthModal = ({ authType, handleChangeAuthType, showAuthModal, handleModeChangeAuthModal }) => {

  const languageState = useSelector((state) => state.languageState);
  const accountList = useSelector((state) => state.accountState.account_list);
  const gameLaunchLang = useSelector((state) => state.gameLaunchLanguageState);

  let gameLaunchLangList = gameLaunchLang.game_launch_language_list;
  let selectedGameLaunchLang = gameLaunchLang.selected_language;
  let languageCode = languageState.active_language.language_code;

  const dispatch = useDispatch();

  const [state, setState] = useState({
    name: "",
    nick_name: "",
    email: "",
    password: "",
    // preffered_currency: "",
    preffered_account: "",
  });

  const [nameErrors, setNameErrors] = useState("");
  const [nickNameErrors, setNickNameErrors] = useState("");
  const [currencyErrors, setCurrencyErrors] = useState("");
  const [emailErrors, setEmailErrors] = useState("");
  const [passwordErrors, setPasswordErrors] = useState("");
  const [accountErrors, setAccountErrors] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  /* Validation Checking */
  const ValidateForm = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      AuthSubmitClick();
    }
    else {
      toast.error(<FormattedMessage id='PLEASEFILLALLFIELDS' />, {
        position: "bottom-right",
      })
    }
  }

  /* Validate all fields */
  const handleValidation = (e) => {
    let nameErrors, nickNameErrors, currencyErrors, emailErrors, passwordErrors, accountErrors;
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    let formIsValid = true;

    if (authType == "register" && !state.name) {
      formIsValid = false;
      nameErrors = <FormattedMessage id='NAMECANNOTBEEMPTY' />;
      setNameErrors(nameErrors);
    } else {
      setNameErrors('');
    }

    if (authType == "register" && !state.nick_name) {
      formIsValid = false;
      nickNameErrors = <FormattedMessage id='NICKNAMECANNOTBEEMPTY' />;
      setNickNameErrors(nickNameErrors);
    } else {
      setNickNameErrors('');
    }

    // if (authType=="register" && !state.preffered_currency) {
    //   formIsValid = false;
    //   currencyErrors =  <FormattedMessage id='CURRENCYCANNOTBEEMPTY' />;
    //   setCurrencyErrors(currencyErrors);
    // } else {
    //   setCurrencyErrors('');
    // }

    if (!state.email) {
      formIsValid = false;
      emailErrors = <FormattedMessage id='EMAILCANNOTBEEMPTY' />;
      setEmailErrors(emailErrors);
    } else if (!state.email.match(isValidEmail)) {
      formIsValid = false;
      emailErrors = "Please enter valid email";
      setEmailErrors(emailErrors);
    } else {
      setEmailErrors('');
    }

    if (!state.password) {
      formIsValid = false;
      passwordErrors = <FormattedMessage id='PASSWORDCANNOTBEEMPTY' />;
      setPasswordErrors(passwordErrors);
    } else {
      setPasswordErrors('');
    }

    if (!state.preffered_account) {
      formIsValid = false;
      accountErrors = <FormattedMessage id='ACCOUNTCANNOTBEEMPTY' />;
      setAccountErrors(accountErrors);
    } else {
      setAccountErrors('');
    }

    return formIsValid;
  }

  /**
   * @author Swarnali Ghosh
   * @Date_Created 01/03/2023
   * @Date_Modified 05/03/2023
   * @function async
   * @functionName AuthSubmitClick
   * @functionPurpose this function use for login.
   * @functionParam {payload object:name,nick_name,preffered_currency,email,password}
   * @functionSuccess Success status and message.
   * @functionError {Boolean} error is there.
   * @functionError {String} message  Description message.
   */
  const AuthSubmitClick = async (e) => {

    const is_loading = false;
    setLoadingState(true)

    if (authType == "register") {
      let params = JSON.stringify({
        name: state.name,
        nick_name: state.nick_name,
        // preffered_currency: state.preffered_currency,
        email: state.email,
        password: state.password,
        account_id: state.preffered_account,
      })

      GeneralService.apiPostCallRequest(ApiURL.register, params, "").then(res => {
        if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
          setLoadingState(false);
          if (res.message == "User already registered") {
            setLoadingState(false);
            toast.info(res.message, {
              position: "bottom-right",
            })
          }
          else {
            closeAuthModal();
            toast.success(res.message, {
              position: "bottom-right",
            })
          }

        } else {
          setLoadingState(false);
          setLoadingState(false);
          toast.error(res.message, {
            position: "bottom-right",
          })
        }
      }).catch(error => {
        setLoadingState(false);
        setLoadingState(false);
        console.log(error);
      })

    } else {
      let params = JSON.stringify({
        email: state.email,
        password: state.password,
        account_id: state.preffered_account
      })
      GeneralService.apiPostCallRequest(ApiURL.login, params, "").then(res => {
        if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {

          if (res.message == "Password Mismatch" || res.message == "User Not Registered" || res.message == "Invalid account") {
            setLoadingState(false);
            // setLoadingState(false);
            toast.info(res.message, {
              position: "bottom-right",
            })


          } else if (res.message === "Login Success") {
            setLoadingState(false);
            // setLoadingState(false);
            handleModeChangeAuthModal()

            setState(prevState => ({
              ...prevState,
              email: "",
              password: ""
            }))

            dispatch(storeUserDetails(res.data))
            dispatch(storeLoginCredentials({
              email: state.email,
              password: state.password,
              account_id: state.preffered_account
            }))

            toast.success(<FormattedMessage id='LOGINSUCCESSFULLY' />, {
              position: "bottom-right",
            })
          }

        } else {
          setLoadingState(false);
          setLoadingState(false);
          toast.error(res.message, {
            position: "bottom-right",
          })


        }
      }).catch(error => {
        setLoadingState(false);
        setLoadingState(false);
        console.log(error);
      })
    }
  }

  const closeAuthModal = () => {

    setState(prevState => ({
      ...prevState,
      email: "",
      password: "",
      nick_name: "",
      preffered_currency: "",
      name: ""
    }))

    setEmailErrors("")
    setNameErrors("")
    setNickNameErrors("")
    setPasswordErrors("")
    setAccountErrors("")
    setCurrencyErrors("")

    handleModeChangeAuthModal()
  }

  const changeAuthMode = () => {
    setEmailErrors("")
    setNameErrors("")
    setNickNameErrors("")
    setPasswordErrors("")
    setAccountErrors("")
    setCurrencyErrors("")

    setState(prevState => ({
      ...prevState,
      email: "",
      password: "",
      nick_name: "",
      preffered_account: "",
      name: ""
    }))

    handleChangeAuthType()
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      AuthSubmitClick();
    }
  };

  return (
    <>
      <Modal
        show={showAuthModal}
        onHide={closeAuthModal}
        backdrop="static"
        centered
      >
        <div className="apply_comp_sec">
          <Loader loadingStatus={loadingState} />
          <Modal.Header closeButton className='py-3'>
            <h6 className="hed_txt m-0">{authType == "login" ?
              <FormattedMessage id='LOGIN' />
              : <FormattedMessage id='REGISTER' />}</h6>
          </Modal.Header>

          <div className="">
            <div className="">
              <div className="row login-register-form">

                <div className="col-md-12 input-display" hidden={authType == "login" ? true : false}>

                  <label htmlFor="name">
                    <FormattedMessage id='NAME' />
                    <span className='v-error'>  * </span></label>
                  <input
                    id="name"
                    placeholder={languageCode == "en" ? "Enter name" : "이름을 입력하시오"}
                    value={state.name}
                    onChange={handleChange}
                  />
                  <span className='v-error'>{nameErrors}</span>
                </div>

                <div className="col-md-12 input-display" hidden={authType == "login" ? true : false} >

                  <label htmlFor="name">
                    <FormattedMessage id='NICKNAME' />
                    <span className='v-error'>  * </span></label>
                  <input
                    id="nick_name"
                    placeholder={languageCode == "en" ? "Enter nick name" : "닉네임을 입력하세요"}
                    value={state.nick_name}
                    onChange={handleChange}
                  />
                  <span className='v-error'>{nickNameErrors}</span>
                </div>

                {/* <div className="col-md-12 input-display" hidden={authType == "login" ? true : false}>

                  <label htmlFor="preffered_currency">
                    <FormattedMessage id='CURRENCY' />
                    <span className='v-error'>  * </span></label>
                  <select id='preffered_currency' name='preffered_currency' value={state.preffered_currency} onChange={handleChange}>
                    <option value="" ><FormattedMessage id='SELECTCURRENCY' /></option>
                    {currencyList?.length>0 ? currencyList.map((item, keyIndex) => {
                      return <option key={keyIndex} value={item.currency_code}>{item.currency_code}</option>
                    }) : ""}
                  </select>
                  <span className='v-error'>{currencyErrors}</span>
                </div> */}

                <div className="col-md-12 input-display">

                  <label htmlFor="email" >
                    <FormattedMessage id='EMAIL' />
                    <span className='v-error'> * </span></label>

                  <input
                    id="email"
                    placeholder={languageCode == "en" ? "Enter email" : "이메일을 입력하세요"}
                    value={state.email}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />

                  <span className='v-error'>{emailErrors}</span>
                </div>

                <div className="col-md-12 input-display showHidePass">

                  <label htmlFor="password" >
                    <FormattedMessage id='PASSWORD' />
                    <span className='v-error'> * </span></label>

                  <input type={showPassword === true ? "text" : "password"}
                    id="password"
                    placeholder={languageCode == "en" ? "Enter password" : "암호를 입력"}
                    value={state.password}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                  <div className="input-group-addon">
                    <i className={`fa ${showPassword === true ? "fa-eye" : "fa-eye-slash"} `} aria-hidden="true" onClick={() => { setShowPassword(!showPassword) }}></i>
                  </div>

                  <span className='v-error'>{passwordErrors}</span>
                </div>

                {/*Input fields for account dropdown */}
                <div className="col-md-12 input-display showHidePass">

                  <label htmlFor="preffered_account">
                    <FormattedMessage id='ACCOUNT' />
                    <span className='v-error'>  * </span></label>
                  <select id='preffered_account' name='preffered_account' value={state.preffered_account} onChange={handleChange}>
                    <option value="" ><FormattedMessage id='SELECTACCOUNT' /></option>
                    {accountList?.length > 0 ? accountList.map((item, keyIndex) => {
                      return <option key={keyIndex} value={item._id}>{item.account_name} ({item.currency_support})</option>
                    }) : ""}
                  </select>

                  <span className='v-error'>{accountErrors}</span>
                </div>

                {/*Input fields for game launch language dropdown */}
                <div className="col-md-12 input-display showHidePass">

                  <label htmlFor="game_launch_language">
                    <FormattedMessage id='GAMELAUNCHLANGUAGE' />
                    {/* <span className='v-error'>  * </span> */}
                    </label>
                  <select id='game_launch_language' name='game_launch_language' value={selectedGameLaunchLang} onChange={(e) => dispatch(setSelectedLanguage(e.target.value))}>
                    <option value="" ><FormattedMessage id='SELECTGAMELAUNCHLANGUAGE' /></option>
                    {gameLaunchLangList?.length > 0 ? gameLaunchLangList.map((item, keyIndex) => {
                      return <option key={keyIndex} value={item.language_code}>{item.language_name}</option>
                    }) : ""}
                  </select>

                  {/* <span className='v-error'>{accountErrors}</span> */}
                </div>

                <div className='not_registered mt-4'
                  hidden={authType == "login" ? false : true}
                >
                  <FormattedMessage id='NOTREGISTERED' />
                  <span className='not_registered_span ms-2' onClick={changeAuthMode} >
                    <FormattedMessage id='CREATEANACCOUNT' />
                  </span></div>

                <div className='not_registered mt-4'
                  hidden={authType == "login" ? true : false}
                >
                  <FormattedMessage id='HAVEANACCOUNT' />
                  <span className='not_registered_span ms-2' onClick={changeAuthMode} >
                    <FormattedMessage id='LOGINHERE' />
                  </span></div>
              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-md-10 offset-md-1 save-cancel-btn">
              <button
                // disabled={submitDisable ? true : false}
                className="save_btn" style={{ marginRight: 10 }}
                onClick={ValidateForm}
              >
                <FormattedMessage id='SUBMIT' />
              </button>
              <button className="cancel_btn"
                onClick={closeAuthModal}
              >
                <FormattedMessage id='CANCEL' />
              </button>
            </div>
          </div>

        </div>
      </Modal>
    </>
  )
}

export default AuthModal
